var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#EE741F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2922 22.9106L24.2512 16.9622L24.2002 16.995C24.5455 16.793 24.7617 16.4147 24.7617 15.9999L24.7564 15.8878C24.7248 15.5549 24.5538 15.2548 24.2911 15.0643L24.2512 15.0384L18.2921 9.08924L18.2064 9.01263C17.7513 8.65814 17.1228 8.68729 16.7199 9.07188L16.6416 9.15466C16.2755 9.58339 16.294 10.2248 16.7021 10.6324L20.9324 14.8571L8.34386 14.8571L8.23626 14.8629C7.65553 14.9331 7.23791 15.4226 7.23791 15.9999L7.24293 16.1094C7.29608 16.6859 7.7649 17.1428 8.34386 17.1428H20.9347L16.7022 21.3675L16.6255 21.453C16.2674 21.912 16.3124 22.539 16.7199 22.928C17.1599 23.348 17.8618 23.3403 18.2922 22.9106Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeNext);
export default __webpack_public_path__ + "static/media/orange-next.765bcff4356316ad270cda6f637372cc.svg";
export { ForwardRef as ReactComponent };